import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

export interface UseChristmasLogoReturn {
  showChristmasLogo: boolean;
  showNewYearGreeting: boolean;
}

export const useChristmasLogo = (): UseChristmasLogoReturn => {
  const [showChristmasLogo, setShowChristmasLogo] = useState<boolean>(false);
  const [showNewYearGreeting, setShowNewYearGreeting] = useState<boolean>(false);

  useEffect(() => {
    const checkDateRanges = () => {
      const now = dayjs();
      const currentMonth = now.month();
      const currentDate = now.date();

      const isChristmasRange = currentMonth === 11 && currentDate >= 25 && currentDate <= 31;
      const isNewYearRange = currentMonth === 0 && currentDate >= 1 && currentDate <= 7;

      setShowChristmasLogo(isChristmasRange);
      setShowNewYearGreeting(isNewYearRange);
    };

    checkDateRanges();

    const interval = setInterval(checkDateRanges, 24 * 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return {
    showChristmasLogo,
    showNewYearGreeting,
  };
};

export default useChristmasLogo;
